import React, { useState } from 'react';

const TermsSection = ({ id, title, icon, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className="bg-white overflow-hidden rounded-[20px] transition-all duration-300"
      id={id}
      style={{ boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)' }}
    >
      <div
        className="flex justify-between items-center cursor-pointer bg-fondo-claro hover:bg-blue-50 transition-all duration-300 px-[30px] py-[25px] border-b-2 border-[#e8f0fe]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-5">
          <div className="flex items-center justify-center flex-shrink-0 text-white w-[45px] h-[45px] bg-gradient-to-br from-icetex to-icetex-dark rounded-full">
            <span className="w-6 h-6 flex items-center justify-center">
              {icon}
            </span>
          </div>
          <h3 className="text-texto-oscuro font-bold m-0 text-[1.3rem]">
            {title}
          </h3>
        </div>
        <button
          className="bg-transparent border-0 cursor-pointer flex items-center justify-center p-2"
          aria-expanded={isOpen}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-icetex"
            style={{
              width: '24px',
              height: '24px',
              transition: 'transform 0.3s ease',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>
      <div
        className="overflow-hidden"
        style={{
          maxHeight: isOpen ? '3000px' : '0',
          transition: 'max-height 0.4s ease',
          padding: isOpen ? '30px' : '0 30px',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default TermsSection;
